module.exports = __webpack_public_path__ + "img/learning.534ce90a.png";